import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Login() {
  const { login } = useAuth();
  const navigate  = useNavigate();
  const [email, setEmail]     = useState('');
  const [senha, setSenha]     = useState('');
  const [erro, setErro]       = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setErro('');
    setLoading(true);
    try {
      await login(email, senha);
      navigate('/');
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao fazer login.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={styles.wrap}>
      <div style={styles.card} className="animate-fade">

        {/* Logo */}
        <div style={styles.brand}>
          <div style={styles.brandIcon}>
            <i className="ti ti-brand-whatsapp" style={{ fontSize: 22, color: '#fff' }} />
          </div>
          <span style={styles.brandName}>
            Chat <span style={{ color: '#25D366' }}>MJ</span>
          </span>
        </div>

        <p style={styles.subtitle}>Faça login para acessar a plataforma</p>

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.field}>
            <label style={styles.label}>Email</label>
            <div style={styles.inputWrap}>
              <i className="ti ti-mail" style={styles.inputIcon} />
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="seu@email.com"
                required
                style={styles.input}
              />
            </div>
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Senha</label>
            <div style={styles.inputWrap}>
              <i className="ti ti-lock" style={styles.inputIcon} />
              <input
                type="password"
                value={senha}
                onChange={e => setSenha(e.target.value)}
                placeholder="••••••••"
                required
                style={styles.input}
              />
            </div>
          </div>

          {erro && <p style={styles.erro}>{erro}</p>}

          <button type="submit" disabled={loading} style={styles.btn}>
            {loading
              ? <><i className="ti ti-loader-2" style={{ animation: 'spin 1s linear infinite' }} /> Entrando...</>
              : <><i className="ti ti-login" /> Entrar</>
            }
          </button>
        </form>

        <p style={styles.footer}>Chat MJ · Plataforma de Atendimento</p>
      </div>

      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        input:focus { border-color: #25D366 !important; box-shadow: 0 0 0 3px rgba(37,211,102,0.15) !important; }
      `}</style>
    </div>
  );
}

const styles = {
  wrap: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #1a1f2e 0%, #0d1117 100%)',
    padding: 24,
  },
  card: {
    background: '#fff',
    borderRadius: 20,
    padding: '40px 36px',
    width: '100%',
    maxWidth: 400,
    boxShadow: '0 24px 80px rgba(0,0,0,0.3)',
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    marginBottom: 8,
  },
  brandIcon: {
    width: 44,
    height: 44,
    borderRadius: 12,
    background: '#25D366',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  brandName: {
    fontSize: 24,
    fontWeight: 600,
    color: '#1a1f2e',
    letterSpacing: '-0.5px',
  },
  subtitle: {
    fontSize: 13,
    color: '#8696a0',
    marginBottom: 28,
  },
  form: { display: 'flex', flexDirection: 'column', gap: 16 },
  field: { display: 'flex', flexDirection: 'column', gap: 6 },
  label: { fontSize: 12, fontWeight: 500, color: '#54656f' },
  inputWrap: { position: 'relative' },
  inputIcon: {
    position: 'absolute', left: 12, top: '50%',
    transform: 'translateY(-50%)', fontSize: 16, color: '#8696a0',
  },
  input: {
    width: '100%',
    padding: '10px 12px 10px 38px',
    borderRadius: 10,
    border: '1.5px solid #e9edef',
    background: '#f0f2f5',
    fontSize: 13,
    color: '#1a1f2e',
    transition: 'all 0.15s',
  },
  erro: {
    fontSize: 12,
    color: '#dc2626',
    background: '#fef2f2',
    padding: '8px 12px',
    borderRadius: 8,
    border: '1px solid #fca5a5',
  },
  btn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    padding: '11px 0',
    borderRadius: 10,
    border: 'none',
    background: '#25D366',
    color: '#fff',
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'background 0.15s',
    marginTop: 4,
  },
  footer: {
    textAlign: 'center',
    fontSize: 11,
    color: '#c4c4c4',
    marginTop: 24,
  },
};
